export default __webpack_public_path__ + "static/media/add.e93dee11.svg";